<template>
  <v-hover>
    <v-btn
      slot-scope="{ hover }"
      flat
      icon
      :color="`${hover ? finalFileHoverColor : finalFileColor}`"
      @click="$emit('click')"
    >
      <v-badge small :color="finalBadgeColor" flat overlap>
        <v-icon v-if="!hover" flat slot="badge">{{ finalBadgeIcon }}</v-icon>
        <v-icon
          :color="`${hover ? finalFileHoverColor : finalFileColor}`"
          v-html="`${hover ? finalHoverIcon : finalFileIcon}`"
        ></v-icon>
      </v-badge>
    </v-btn>
  </v-hover>
</template>

<script>
export default {
  props: [
    'status',
    'color',
    'badgeColor',
    'fileColor',
    'fileHoverColor',
    'badgeIcon',
    'fileIcon',
    'fileHoverIcon',
  ],
  data() {
    return {};
  },
  computed: {
    finalBadgeIcon() {
      if (this.badgeIcon) {
        return this.badgeIcon;
      } else {
        let icon = '';
        switch (this.status) {
          case 'in-process':
            icon = 'mdi-clock-outline';
            break;
          case 'finish':
            icon = 'mdi-check';
            break;
          case 'error':
            icon = 'mdi-alert-circle-outline';
            break;
          default:
            icon = 'mdi-clock-outline';
            break;
        }
        return icon;
      }
    },
    finalFileIcon() {
      return this.fileIcon ? this.fileIcon : 'mdi-file-document-outline';
    },
    finalHoverIcon() {
      return this.fileHoverIcon ? this.fileHoverIcon : 'mdi-download-outline';
    },
    finalColor() {
      return this.color ? this.color : 'grey lighten-1';
    },
    finalBadgeColor() {
      return this.badgeColor ? this.badgeColor : this.finalColor;
    },
    finalFileColor() {
      return this.fileColor ? this.fileColor : this.finalColor;
    },
    finalFileHoverColor() {
      return this.fileHoverColor ? this.fileHoverColor : this.finalFileColor;
    },
  },
};
</script>

<style></style>
